export default "__VITE_ASSET__CfwyFQfN__";